import regexList from "./utils/regexList";
import regexTest from "./utils/regexTest";


export default function isPhone(str, responseText) {
    const regVal = regexList.phone.pattern;
    return regexTest(str, regVal, responseText) || regexList.phone.response;
}